import * as React from 'react';
import { Field, FieldArray, FormikProps } from 'formik';

import { GeneralInformationFormData } from './types';
import { CheckboxInput } from '../input-checkbox';
import { arrayToRows } from '../../utils/arrays';

interface Style {
    label: string;
    value: number;
}

interface OwnProps {
    formikProps: FormikProps<GeneralInformationFormData>;

    styles: Style[];
}

export class StylesCard extends React.Component<OwnProps, {}> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        const { formikProps } = this.props;

        const topLevelError = typeof formikProps.errors.styles === 'string' ? formikProps.errors.styles : null;

        return (
            <div className='VenueManagement--card VenueManagement--styles'>
                <div className='VenueManagement--card--header'>Style</div>
                <div className='VenueManagement--card--subheader'>You can select up to 6 styles for a venue.</div>
                <div className='VenueManagement--card--body'>
                    <div className='VenueManagement--card--section'>
                        {!!topLevelError && <div className='VenueManagement--form-level-error'>{topLevelError}</div>}
                        <FieldArray
                            name='styles'
                            render={(arrayHelpers) => {
                                return arrayToRows(this.props.styles).map((row, idx) => {
                                    return (
                                        <div key={idx} className='VenueManagement--row'>
                                            {row.map((col, colIdx) => {
                                                return (
                                                    <div className='VenueManagement--col' key={colIdx}>
                                                        {!!col && (
                                                            <Field
                                                                label={col.label}
                                                                component={CheckboxInput}
                                                                name={`styles.${this.props.styles.indexOf(col)}`}
                                                                value={col.value}
                                                                checked={formikProps.values.styles.indexOf(col.value) > -1}
                                                                onChange={(e: React.SyntheticEvent<HTMLInputElement>) => {
                                                                    if ((e.target as HTMLInputElement).checked) {
                                                                        arrayHelpers.push(col.value);
                                                                    } else {
                                                                        const idx = formikProps.values.styles.indexOf(col.value);
                                                                        arrayHelpers.remove(idx);
                                                                    }
                                                                }}
                                                                hideErrors={true}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
